const CirculoInformacion = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="#006299" />
      <circle cx="5" cy="10" r="2" fill="white" />
      <circle cx="10" cy="10" r="2" fill="white" />
      <circle cx="15" cy="10" r="2" fill="white" />
    </svg>
  );
};

export default CirculoInformacion;
